export const APP_VERSION = '0.1.3'
export const VERSION_CHECK_PATH = 'version.json'
export const VERSION_RELOAD_SESSION_KEY = 'beici:version:reloaded'
